module.exports = __webpack_public_path__ + "assets/img/report-act-bg-11.fd31f09b.png";